export const CONTEXT_MENU_ITEMS = {
  ADD_ACTIONS: 'CONTEXT_MENU.ADD_ACTIONS',
  OPTIMIZATION_STATUS_UPDATE: 'CONTEXT_MENU.OPTIMIZATION_STATUS_UPDATE',
  ASSIGNEE_UPDATE: 'CONTEXT_MENU.ASSIGNEE_UPDATE',
  METAFIELD_VALUE_UPDATE: 'CONTEXT_MENU.METAFIELD_VALUE_UPDATE',

  ADD_CHANGES: 'CONTEXT_MENU.ADD_CHANGES',
  ADD_EXISTING_STORY: 'CONTEXT_MENU.ADD_TO_EXISTING_STORY',
  ADD_MULTIPLE_STORIES: 'CONTEXT_MENU.ADD_MULTIPLE_STORIES',
  ADD_NEW_STORY: 'CONTEXT_MENU.ADD_NEW_STORY',
  CREATE_REQUIREMENT: 'CONTEXT_MENU.CREATE_REQUIREMENT',

  ADD_DOCUMENTATION: 'CONTEXT_MENU.ADD_DOCUMENTATION',
  NOTE: 'CONTEXT_MENU.NOTE',
  URL: 'CONTEXT_MENU.URL',
  DATA_TABLE: 'CONTEXT_MENU.DATA_TABLE',
  IMAGE: 'CONTEXT_MENU.IMAGE',

  DEPENDENCIES: 'CONTEXT_MENU.DEPENDENCIES',
  ADD_DEPENDENCY: 'CONTEXT_MENU.ADD_DEPENDENCY',
  COPY_NODE: 'CONTEXT_MENU.COPY_NODE',
  OPEN_DEPENDENCY_TREE: 'ATTACHMENTS.OPEN_DEPENDENCY_TREE',
  OPEN_DEPENDENCY_GRID: 'DEPENDENCY_TREE.OPEN_DEPENDENCY_GRID',

  TAGS: 'CONTEXT_MENU.TAGS',
  TAGS_REPLACE: 'CONTEXT_MENU.TAGS_REPLACE',
  TAGS_ADD: 'CONTEXT_MENU.TAGS_ADD',

  ADD_PROPOSED_NODE: 'CONTEXT_MENU.ADD_NEW_PROPOSED_NODE',

  CREATE_NEW_NODE: 'CONTEXT_MENU.CREATE_NEW_NODE',
  SIBLING_NODE: 'CONTEXT_MENU.SIBLING_NODE',
  CHILD_NODE: 'CONTEXT_MENU.CHILD_NODE'
} as const;

export const CONTEXT_MENU_TRACK_VALUES = {
  ADD_ACTIONS: 'CONTEXT_MENU.ADD_ACTIONS',
  ASSESSMENT_STATUS_UPDATE: 'CONTEXT_MENU.ADD_ACTIONS.ASSESSMENT_STATUS_UPDATE',
  ASSIGNEE_UPDATE: 'CONTEXT_MENU.ADD_ACTIONS.ASSIGNEE_UPDATE',
  METAFIELD_VALUE_UPDATE: 'CONTEXT_MENU.ADD_ACTIONS.METAFIELD_VALUE_UPDATE',

  CODE_SEARCH_ADD_ACTIONS: 'CONTEXT_MENU.CODE_SEARCH.ADD_ACTIONS',
  CODE_SEARCH_ASSESSMENT_STATUS_UPDATE:
    'CONTEXT_MENU.CODE_SEARCH.ADD_ACTIONS.ASSESSMENT_STATUS_UPDATE',
  CODE_SEARCH_ASSIGNEE_UPDATE: 'CONTEXT_MENU.CODE_SEARCH.ADD_ACTIONS.ASSIGNEE_UPDATE',
  CODE_SEARCH_METAFIELD_VALUE_UPDATE: 'CONTEXT_MENU.CODE_SEARCH.ADD_ACTIONS.METAFIELD_VALUE_UPDATE',

  ADD_CHANGES: 'CONTEXT_MENU.ADD_CHANGES',
  ADD_EXISTING_STORY: 'CONTEXT_MENU.ADD_CHANGES.ADD_TO_EXISTING_STORY',
  ADD_MULTIPLE_STORIES: 'CONTEXT_MENU.ADD_CHANGES.ADD_MULTIPLE_STORIES',
  ADD_NEW_STORY: 'CONTEXT_MENU.ADD_CHANGES.ADD_NEW_STORY',
  CREATE_REQUIREMENT: 'CONTEXT_MENU.ADD_CHANGES.CREATE_REQUIREMENT',

  CODE_SEARCH_ADD_CHANGES: 'CONTEXT_MENU.CODE_SEARCH.ADD_CHANGES',
  CODE_SEARCH_ADD_EXISTING_STORY: 'CONTEXT_MENU.CODE_SEARCH.ADD_CHANGES.ADD_TO_EXISTING_STORY',
  CODE_SEARCH_ADD_MULTIPLE_STORIES: 'CONTEXT_MENU.CODE_SEARCH.ADD_CHANGES.ADD_MULTIPLE_STORIES',
  CODE_SEARCH_ADD_NEW_STORY: 'CONTEXT_MENU.CODE_SEARCH.ADD_CHANGES.ADD_NEW_STORY',

  ADD_DOCUMENTATION: 'CONTEXT_MENU.ADD_DOCUMENTATION',
  NOTE: 'CONTEXT_MENU.ADD_DOCUMENTATION.NOTE',
  URL: 'CONTEXT_MENU.ADD_DOCUMENTATION.URL',
  DATA_TABLE: 'CONTEXT_MENU.ADD_DOCUMENTATION.DATA_TABLE',
  IMAGE: 'CONTEXT_MENU.ADD_DOCUMENTATION.IMAGE',

  CODE_SEARCH_ADD_DOCUMENTATION: 'CONTEXT_MENU.CODE_SEARCH.ADD_DOCUMENTATION',
  CODE_SEARCH_NOTE: 'CONTEXT_MENU.CODE_SEARCH.ADD_DOCUMENTATION.NOTE',
  CODE_SEARCH_URL: 'CONTEXT_MENU.CODE_SEARCH.ADD_DOCUMENTATION.URL',
  CODE_SEARCH_DATA_TABLE: 'CONTEXT_MENU.CODE_SEARCH.ADD_DOCUMENTATION.DATA_TABLE',
  CODE_SEARCH_IMAGE: 'CONTEXT_MENU.CODE_SEARCH.ADD_DOCUMENTATION.IMAGE',

  DEPENDENCIES: 'CONTEXT_MENU.DEPENDENCIES',
  ADD_DEPENDENCY: 'CONTEXT_MENU.DEPENDENCIES.ADD_DEPENDENCY',
  COPY_NODE: 'CONTEXT_MENU.DEPENDENCIES.COPY_COMPONENT_REFERENCE',
  OPEN_DEPENDENCY_TREE: 'CONTEXT_MENU.DEPENDENCIES.OPEN_DEPENDENCY_TREE',
  OPEN_DEPENDENCY_GRID: 'CONTEXT_MENU.DEPENDENCIES.OPEN_DEPENDENCY_GRID',

  CODE_SEARCH_DEPENDENCIES: 'CONTEXT_MENU.CODE_SEARCH.DEPENDENCIES',
  CODE_SEARCH_ADD_DEPENDENCY: 'CONTEXT_MENU.CODE_SEARCH.DEPENDENCIES.ADD_DEPENDENCY',
  CODE_SEARCH_COPY_NODE: 'CONTEXT_MENU.CODE_SEARCH.DEPENDENCIES.COPY_COMPONENT_REFERENCE',
  CODE_SEARCH_OPEN_DEPENDENCY_TREE: 'CONTEXT_MENU.CODE_SEARCH.DEPENDENCIES.OPEN_DEPENDENCY_TREE',
  CODE_SEARCH_OPEN_DEPENDENCY_GRID: 'CONTEXT_MENU.CODE_SEARCH.DEPENDENCIES.OPEN_DEPENDENCY_GRID',

  RUN_CODE_SEARCH: 'CONTEXT_MENU.RUN_CODE_SEARCH',
  RUN_NODE_CODE_SEARCH: 'CONTEXT_MENU.RUN_NODE_CODE_SEARCH',

  CODE_SEARCH_RUN_CODE_SEARCH: 'CONTEXT_MENU.CODE_SEARCH.RUN_CODE_SEARCH',
  CODE_SEARCH_RUN_NODE_CODE_SEARCH: 'CONTEXT_MENU.CODE_SEARCH.RUN_NODE_CODE_SEARCH',

  TAGS: 'CONTEXT_MENU.TAGS',
  TAGS_REPLACE: 'CONTEXT_MENU.TAGS.TAGS_REPLACE',
  TAGS_ADD: 'CONTEXT_MENU.TAGS.TAGS_ADD',

  CODE_SEARCH_TAGS: 'CONTEXT_MENU.CODE_SEARCH.TAGS',
  CODE_SEARCH_TAGS_REPLACE: 'CONTEXT_MENU.CODE_SEARCH.TAGS.TAGS_REPLACE',
  CODE_SEARCH_TAGS_ADD: 'CONTEXT_MENU.CODE_SEARCH.TAGS.TAGS_ADD',

  MAKE_NODE_ROOT: 'CONTEXT_MENU.MAKE_NODE_ROOT',
  ADD_PROPOSED_NODE: 'CONTEXT_MENU.ADD_PROPOSED_NODE',
  SHOW_IN_METADATA_DICTIONARY: 'CONTEXT_MENU.SHOW_IN_METADATA_DICTIONARY',

  CODE_SEARCH_SHOW_IN_METADATA_DICTIONARY: 'CONTEXT_MENU.CODE_SEARCH.SHOW_IN_METADATA_DICTIONARY',

  CREATE_NEW_NODE: 'CONTEXT_MENU.CREATE_NEW_NODE',
  SIBLING_NODE: 'CONTEXT_MENU.CREATE_NEW_NODE.SIBLING_NODE',
  CHILD_NODE: 'CONTEXT_MENU.CREATE_NEW_NODE.CHILD_NODE'
} as const;
